module.exports = __webpack_public_path__ + "static/media/wave-grc-mob.e98b58b8.svg";